import { CardProps } from '..'
import { Box, Button, Card, CardContent, Grid, Stack, Typography, Divider, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material'
import { DadoValorPrinter } from '../../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter'
import { useState } from 'react';
import DialogEditarDadosFinanceiros from './DialogEditarDadosFinanceiros';
import { formatarCPFCNPJ } from '../../../../../../../helpers/masks';
export default function CardDadosFinanceiros({
    data
}: PropsCardDadosFinanceiros) {

    const [openEditar, setOpenEditar] = useState(false);
    const contasCorrentes = data.contas_corrente || [];

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" mb={2}>
                    Informações financeiras e trabalhistas
                </Typography>

                <Grid container spacing={3}>
                    <Grid size={{xs: 6}}>
                        <DadoValorPrinter titulo="Aliquota INSS" valor={`${data.aliquota_inss}`} />
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <DadoValorPrinter titulo="Aliquota SENAR" valor={`${data.aliquota_senar}`} />
                    </Grid>
                </Grid>

                <Divider sx={{ my: 2 }} />

                {contasCorrentes.length > 0 ? (
                    <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Banco</strong></TableCell>
                                    <TableCell><strong>Agência</strong></TableCell>
                                    <TableCell><strong>Conta</strong></TableCell>
                                    <TableCell><strong>CPF/CNPJ</strong></TableCell>
                                    <TableCell><strong>Status</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {contasCorrentes.map((conta, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell>{`${conta.banco.codigo} - ${conta.banco.nome}`}</TableCell>
                                        <TableCell>{`${conta.agencia}${conta.agencia_digito ? `-${conta.agencia_digito}` : ''}`}</TableCell>
                                        <TableCell>{`${conta.conta}${conta.conta_digito ? `-${conta.conta_digito}` : ''}`}</TableCell>
                                        <TableCell>{conta.cpf_cnpj_conta && conta.cpf_cnpj_conta !== '0' ? formatarCPFCNPJ(conta.cpf_cnpj_conta) : '-'}</TableCell>
                                        <TableCell>
                                            <Chip
                                                label={conta.status}
                                                size="small"
                                                color={conta.status === 'ATIVO' ? 'success' : 'error'}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography variant="body2" color="text.secondary" py={2} mb={3}>
                        Nenhuma conta corrente cadastrada
                    </Typography>
                )}

                <Stack>
                    <Box alignSelf={'self-end'}>
                        <Button onClick={() => { setOpenEditar(true) }} variant="outlined" color="primary" size="small" sx={{ mt: 1 }}>
                            Editar
                        </Button>
                    </Box>
                </Stack>
            </CardContent>

            {
                openEditar &&
                <DialogEditarDadosFinanceiros
                    open={openEditar}
                    onClose={() => setOpenEditar(false)}
                    data={data}
                />
            }
        </Card>
    )
}


interface PropsCardDadosFinanceiros extends CardProps {
}
